'use client';

import React, { useState } from 'react';
import Register from '@/components/Register';
import Head from 'next/head';
import Footer from '@/components/Footer';
import { PageMetadataUpdater } from '@/hooks/usePageMetadata';

export default function RegisterPage() {
  const [user, setUser] = useState(null);

  return (
    <div className="min-h-screen">
      <PageMetadataUpdater pageKey="register" />
      <Register onLogin={setUser} />
      <Footer />
    </div>
  );
}